import PlatformActions from './PlatformActions'

// TABLE
// (rollout > rollin)
// winAmount = betAmount + gameInfo.win - gameInfo.rake - gameInfo.roomFee

// SLOT
// (bet > endRound)
// winAmount = gameInfo.amount

// EGAME
// (rollout > rollin)
// winAmount = betAmount - turnover + gameInfo.win

// FISH
// (rollout > rollin)
// winAmount = betAmount - turnover + gameInfo.win

export default class CQ9FISHActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'FH',
      gameCode: 'CQ9-FISH-001',
      platform: 'CQ9',
    }

    this.gameName = 'Oneshot Fishing'
    this.roundIdPrefix = 'AT01m'
    this.roundIdSuffix = 'm1m1'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `rel-rollout-${this.roundIdPrefix}${txnId}${this.roundIdSuffix}:cq9`, // rel-rollout-AT01m335092m1m1:cq9
      roundId: `${this.roundIdPrefix}${roundId}${this.roundIdSuffix}`, // AT01m335092m1m1
      betType: null,
      currency,
      betTime, // 2026-06-15T13:57:44.161+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      realWinAmount,
      rake,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${this.roundIdPrefix}${txnId}${this.roundIdSuffix}`, // AT01m335092m1m1
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2026-06-15T13:59:00.467+08:00
      roundId: `${this.roundIdPrefix}${roundId}${this.roundIdSuffix}`, // AT01m335092m1m1
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      // realWinAmount, // dev used
      jackpotWinAmount: 0,
      gameInfo: {
        roomFee: 0,
        rake,
        win: realWinAmount,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getResettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      realWinAmount,
      rake,
      resettleTime,
      debitAmount,
      creditAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${this.roundIdPrefix}${txnId}${this.roundIdSuffix}`, // AT01m335092m1m1
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime,
      roundId: `${this.roundIdPrefix}${roundId}${this.roundIdSuffix}`, // AT01m335092m1m1
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      // realWinAmount, // dev used
      gameInfo: {
        roomFee: 0,
        rake,
        win: realWinAmount,
        ...(debitAmount && { [`debit_resettle-${this.roundIdPrefix}${roundId}${this.roundIdSuffix}:cq9_adjustAmount`]: debitAmount }),
        ...(creditAmount && { [`credit_resettle-${this.roundIdPrefix}${roundId}${this.roundIdSuffix}:cq9_adjustAmount`]: creditAmount }),
        resettleTime,
      },
    }))

    const message = {
      action: 'resettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `rel-rollout-${this.roundIdPrefix}${txnId}${this.roundIdSuffix}:cq9`, // rel-rollout-AT01m335092m1m1:cq9
      roundId: `${this.roundIdPrefix}${roundId}${this.roundIdSuffix}`, // AT01m335092m1m1
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
